import { createAxiosInstance } from '@/apis/axios.utils';
import { env } from '@/env';

const axios = createAxiosInstance(env.shortURLServiceApiUrl, {
  camelizeKeys: true,
  decamelizeRequests: true,
});

export async function shortenUrl({ url, brandId }, axiosConfig = {}) {
  return axios.post(
    '/api/urls',
    {
      url,
      brandId,
      type: 'SCHEDULER',
    },
    axiosConfig,
  );
}

export async function getUrlInfo(shortCode, axiosConfig = {}) {
  return axios.get(`/api/urls/${shortCode}`, axiosConfig);
}

export default {
  shortenUrl,
  getUrlInfo,
};
